module.exports = __webpack_public_path__ + "img/cross_country.06a9c392.jpg";